import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ComposedField from './ComposedField';
import TextField from '../TextField/TextField';
/**
 * Renders a text field composed with validation and tooltip labels
 */
export default function ComposedTextField(props) {
  return /*#__PURE__*/React.createElement(ComposedField, _extends({}, props, {
    placeholder: props.placeholder ? props.placeholder : props.internalLabel ? props.label : '',
    value: typeof props.value === 'undefined' ? props.value || '' : `${props.value || ''}`
  }), _ref => {
    let {
      doValidation,
      onChange,
      onBlur,
      internalLabel,
      ...composedProps
    } = _ref;
    return /*#__PURE__*/React.createElement(TextField, _extends({}, composedProps, {
      showRequiredInPlaceholder: internalLabel,
      onChange: (val, e) => onChange && onChange(val, e),
      onBlur: e => {
        e === null || e === void 0 ? void 0 : e.persist();
        doValidation(composedProps.value).then(() => onBlur && onBlur(e));
      }
    }));
  });
}